export const FAQ_URL = "swiggy://webviewV2?webview_url=https://www.swiggy.com/support/issues/swiggy-one-faq";

export const TNC_URL = "swiggy://webview?webview_url=https://www.swiggy.com/terms-and-conditions";
